import styled from 'styled-components'
import { Flex } from '@pinchenterprisesnpm/friday-ui'

export const FormSwitchContainer = styled(Flex)`
  /* Layout */
  align-items: center;
  justify-content: space-between;
  width: 90%;

  /* Spacing */
  padding: 10px 16px;
  margin: 0;

  /* Label Container */
  & > div:first-child {
    width: 100%;
    min-width: 30%;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: ${({ theme }) => theme.font.sizes.medium};
    color: ${({ theme }) => theme.palette.dark};
  }
`
